// Lightweight analytics + ad tracking for landing pages.
// - Loads Google Ads + Meta Pixel scripts ONLY when configured (lazy + one-time)
// - Records view/booking_click events to backend
// - Never blocks render; all fetches are fire-and-forget

import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL + '/api';

let loadedGoogleAds = null;   // string: conversion_id once loaded
let loadedMetaPixel = null;   // string: pixel_id once loaded

function ensureGtag() {
  if (window.gtag) return;
  window.dataLayer = window.dataLayer || [];
  window.gtag = function () { window.dataLayer.push(arguments); };
  window.gtag('js', new Date());
}

export function loadGoogleAds(conversionId) {
  if (!conversionId || loadedGoogleAds === conversionId) return;
  try {
    ensureGtag();
    if (loadedGoogleAds !== conversionId) {
      const s = document.createElement('script');
      s.async = true;
      s.src = `https://www.googletagmanager.com/gtag/js?id=${conversionId}`;
      document.head.appendChild(s);
      window.gtag('config', conversionId);
      loadedGoogleAds = conversionId;
    }
  } catch (e) { /* ignore */ }
}

export function loadMetaPixel(pixelId) {
  if (!pixelId || loadedMetaPixel === pixelId) return;
  try {
    if (!window.fbq) {
      /* eslint-disable */
      !function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';n.queue=[];t=b.createElement(e);t.async=!0;t.src=v;s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}(window,document,'script','https://connect.facebook.net/en_US/fbq.js');
      /* eslint-enable */
    }
    window.fbq('init', pixelId);
    window.fbq('track', 'PageView');
    loadedMetaPixel = pixelId;
  } catch (e) { /* ignore */ }
}

export function fireGoogleAdsConversion(conversionId, label) {
  if (!conversionId || !window.gtag) return;
  try {
    const sendTo = label ? `${conversionId}/${label}` : conversionId;
    window.gtag('event', 'conversion', { send_to: sendTo });
  } catch (e) { /* ignore */ }
}

export function fireMetaLead(pixelId) {
  if (!pixelId || !window.fbq) return;
  try { window.fbq('track', 'Lead'); } catch (e) { /* ignore */ }
}

export function sessionId() {
  try {
    let id = sessionStorage.getItem('lp_session_id');
    if (!id) {
      id = `s_${Date.now().toString(36)}_${Math.random().toString(36).slice(2, 8)}`;
      sessionStorage.setItem('lp_session_id', id);
    }
    return id;
  } catch { return null; }
}

function getUtmParams() {
  try {
    const p = new URLSearchParams(window.location.search);
    return {
      utm_source: p.get('utm_source') || null,
      utm_medium: p.get('utm_medium') || null,
      utm_campaign: p.get('utm_campaign') || null,
    };
  } catch { return { utm_source: null, utm_medium: null, utm_campaign: null }; }
}

export function recordEvent(slug, eventType) {
  try {
    const payload = {
      slug, event_type: eventType,
      session_id: sessionId(),
      referrer: (document.referrer || null),
      ...getUtmParams(),
    };
    // fire-and-forget
    axios.post(`${API_URL}/content/landing-events`, payload).catch(() => {});
  } catch { /* ignore */ }
}

// High-level helpers used by LandingPage.js
export function trackView(page) {
  if (!page?.slug) return;
  recordEvent(page.slug, 'view');
  const t = page.tracking || {};
  if (t.google_ads_id) loadGoogleAds(t.google_ads_id);
  if (t.meta_pixel_id) loadMetaPixel(t.meta_pixel_id);
}

export function trackBookingClick(page) {
  if (!page?.slug) return;
  recordEvent(page.slug, 'booking_click');
  const t = page.tracking || {};
  if (t.google_ads_id) fireGoogleAdsConversion(t.google_ads_id, t.google_ads_label);
  if (t.meta_pixel_id) fireMetaLead(t.meta_pixel_id);
}
